import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowsUpFromLine: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm4 6 3-3 3 3' }],
    ['path', { d: 'M7 17V3' }],
    ['path', { d: 'm14 6 3-3 3 3' }],
    ['path', { d: 'M17 17V3' }],
    ['path', { d: 'M4 21h16' }],
  ],
];

export default ArrowsUpFromLine;
